import { render, staticRenderFns } from "./Layout-1.vue?vue&type=template&id=4c250ac8&"
import script from "./Layout-1.vue?vue&type=script&lang=ts&"
export * from "./Layout-1.vue?vue&type=script&lang=ts&"
import style0 from "./Layout-1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports